<template>
  <div class="video-play-container">
    <div class="video-box" ref="video">
      <div v-if="hintTxt" class="hintTxt">{{ hintTxt }}</div>
      <div
        id="playWnd"
        class="playWnd"
        style="background-color: black !important"
      ></div>
    </div>
    <!-- 插件下载 -->
    <el-dialog
      title="提示"
      :visible.sync="downloadVideo"
      width="40%"
      :modal-append-to-body="false"
      destroy-on-close
      :close-on-click-modal="false"
      center
    >
      <downloadVideo
        :base64Url="base64Url"
        @close="shut"
        v-if="downloadVideo"
      ></downloadVideo>
    </el-dialog>
  </div>
</template>

<script>
import { WebControl } from "./web-control.esm.min.js";
import { JSEncrypt } from "./jsencrypt.min";
import downloadVideo from "./modules/downloadVideo.vue";
export default {
  name: "OperatingPlayVideo",
  components: {
    downloadVideo,
  },
  props: {
    videoInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    videoInfo: {
      handler(val) {
        console.log(val);
        this.cameraIndexCode = val.deviceSno;
        this.initPlugin();
      },
      immediate: true,
    },
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  data() {
    return {
      oldType: 0,
      hintTxt: "插件未启动，正在尝试启动，请稍候...",
      initCount: 0, // 初始化次数
      downloadVideo: false, // 是否下载插件
      base64Url: "", // 插件下载地址
      oWebControl: null, // 插件对象
      transMode: 1, // 传输协议
      cameraIndexCode: "", // 监控点编号
      buttonIDs: "0,16,257,259,258,515", // 512
      cameraIndexCodeArr: [
        "2530b71e83ec43988425784c3bc1d485",
        "65c4eab30e504e778b489acca6bdfde2",
        "bebb256dd08c4be3a4e5a5394ac88c03",
        "dbea4b043f5e42e58acb02befbe195be",
        "5ed41ddf1fb941c188058813a3b06047",
        "3c4e72896cf743779754a8ace1bc6a18",
      ], // 监控点编号
      pubKey: null, // 公钥
      screenshot: false, // 截图
      offsetWidth: 0,
      offsetHeight: 0, // 初始化参数
    };
  },
  methods: {
    pullflow() {
      console.log(this.transMode);
      var cameraIndexCode = this.cameraIndexCode; //获取输入的监控点编号值，必填
      var streamMode = 0; //主子码流标识：0-主码流，1-子码流
      var transMode = this.transMode; //传输协议：0-UDP，1-TCP
      var gpuMode = 0; //是否启用GPU硬解，0-不启用，1-启用
      var wndId = -1; //播放窗口序号（在2x2以上布局下可指定播放窗口）

      cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, "");
      cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, "");

      this.oWebControl.JS_RequestInterface({
        funcName: "startPreview",
        argument: JSON.stringify({
          cameraIndexCode: cameraIndexCode, //监控点编号
          streamMode: streamMode, //主子码流标识
          transMode: transMode, //传输协议
          gpuMode: gpuMode, //是否开启GPU硬解
          wndId: wndId, //可指定播放窗口
        }),
      });
    },
    // 回调
    cbIntegrationCallBack(oData) {
      if (oData.responseMsg.msg.picData) {
        this.base64Url = oData.responseMsg.msg.picData;
        this.screenshot = true;

        console.log(this.base64Url);
      }
      console.log("回调");
      if (this.oldType == 2 && this.oldType == oData.responseMsg.type) {
        this.$emit("closeVideo", false);
      }
      this.oldType = 2;
    },
    // 初始化大小
    resize() {
      this.offsetWidth = this.$refs.video.offsetWidth;
      this.offsetHeight = this.$refs.video.offsetHeight;
      this.oWebControl.JS_Resize(this.offsetWidth, this.offsetHeight);
    },
    // 加密
    setEncrypt(value) {
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.pubKey);
      return encrypt.encrypt(value);
    },
    init() {
      console.log("执行了");
      var appkey = "25729696"; //平台提供的 appkey，必填
      var secret = this.setEncrypt("MDxoxMq8MrLpYK6x8Jxl"); // 对 secret 进行 RSA 公钥加密
      var ip = "220.248.163.78"; //平台 IP 地址，必填
      var playMode = 0; // 初始播放模式：0-预览，1-回放，必填
      var port = 1443; //平台端口，若启用 HTTPS 协议，默认 443，必填
      var snapDir = "D:\\SnapDir"; // 抓图存储路径，选填
      var videoDir = "D:\\VideoDir"; // 紧急录像或录像剪辑存储路径，选填
      var layout = "1x1"; // 布局，选填playMode 指定模式的布局，选填
      var enableHTTPS = 1; //是否启用 HTTPS 协议与平台交互，是为 1，否为 0，选填
      var encryptedFields = "secret"; //加密字段，形如'字段 1,...,字段 n'，选填
      this.oWebControl
        .JS_RequestInterface({
          funcName: "init",
          argument: JSON.stringify({
            appkey: appkey,
            secret: secret,
            ip: ip,
            playMode: playMode,
            port: port,
            snapDir: snapDir,
            videoDir: videoDir,
            layout: layout,
            enableHTTPS: enableHTTPS,
            encryptedFields: encryptedFields,
            buttonIDs: this.buttonIDs,
            toolBarButtonIDs: "4098",
          }),
        })
        .then((oData) => {
          this.resize();
          // this.oWebControl.JS_Resize(800, 400);  // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
          this.pullflow();
        });
    },
    // 获取加密信息
    getPubKey() {
      this.oWebControl
        .JS_RequestInterface({
          funcName: "getRSAPubKey",
          argument: JSON.stringify({
            keyLength: 1024,
          }),
        })
        .then((oData) => {
          console.log(oData);
          if (oData.responseMsg.data) {
            this.pubKey = oData.responseMsg.data;
            this.init();
          }
        });
    },
    // 连接本地
    connect() {
      this.oWebControl
        .JS_StartService("window", {
          dllPath: "./VideoPluginConnect.dll",
        })
        .then(() => {
          console.log("执行了");
          this.oWebControl.JS_SetWindowControlCallback({
            // 设置消息回调
            cbIntegrationCallBack: this.cbIntegrationCallBack,
          });
          this.$nextTick(() => {
            this.oWebControl.JS_CreateWnd("playWnd", 0, 0).then(() => {
              console.log("JS_CreateWnd success");
              this.getPubKey();
            });
          });
        });
    },
    // 开始
    initPlugin() {
      this.hintTxt = "插件未启动，正在尝试启动，请稍候...";
      this.oWebControl = new WebControl({
        // 创建 WebControl 实例
        szPluginContainer: "playWnd", // 指定 DIV 窗口标识
        iServicePortStart: 15900, // 指定起止端口号，建议使用该值
        iServicePortEnd: 15900,
        // 用于 IE10 使用 ActiveX 的 clsid
        szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11",
        cbConnectSuccess: () => {
          // 创建 WebControl 实例成功
          console.log("创建成功");
          // 第二部
          this.hintTxt = null;
          this.connect();
        },
        cbConnectError: (e) => {
          this.initCount++;
          if (this.initCount < 3) {
            setTimeout(() => {
              this.initPlugin();
            }, 3000);
          } else {
            this.hintTxt = null;
            this.downloadVideo = true;
          }
          // 创建 WebControl 实例失败
        },
        cbConnectClose: (bNormalClose) => {
          if (bNormalClose) {
            return false;
          }
          this.initCount++;
          if (this.initCount < 3) {
            setTimeout(() => {
              this.initPlugin();
            }, 3000);
          } else {
            this.hintTxt = null;
            this.downloadVideo = true;
          }
          console.log("创建失败");
          console.log(bNormalClose);
          // 插件使用过程中发生的断开与插件服务连接的回调
          // bNormalClose = false 时表示异常断开
          // bNormalClose = true 时表示正常断开
        },
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
    this.oWebControl.JS_HideWnd();
    this.oWebControl.JS_Disconnect();
  },
};
</script>
<style lang="scss">
.video-play-container {
  width: 300px;
  height: 300px;
  background: transparent !important;
}
.video-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
}

.hintTxt {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}
</style>
